import React from "react";

import useAdminParams from "hooks/useAdminParams";
import { useAdmin } from "providers/AdminProvider/AdminProvider";

import { generatePath, Redirect, Route } from "react-router-dom";

import * as routes from "routes";

/**
 * This will be nested in an Admin route,
 * so we can assume globalAdmin and instanceAdmin are already set
 *
 * @param isPortalAdmin
 * @param isGlobalAdmin
 * @param children
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PortalRoute = ({ isPortalAdmin, isGlobalAdmin, children, ...props }) => {
  const { portalId } = useAdminParams();
  const { globalAdmin, instanceAdmin } = useAdmin();

  const portalAdmin = globalAdmin || instanceAdmin;

  if ((isGlobalAdmin && !globalAdmin) || (!isGlobalAdmin && isPortalAdmin && !portalAdmin))
    return <Redirect to={generatePath(routes.PORTAL_ID, { portalId })} />;

  return <Route {...props}>{children}</Route>;
};

export default PortalRoute;
